function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "u02mx5xtca"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.952941 0 0 0 0 0.564706 0 0 0 0 0.129412 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "0r7ktetf5b",
  d: "M4.917 19.607c-.417 0-.834-.08-1.25-.321-1.167-.643-1.584-2.17-.917-3.295l7.083-11.41c.167-.322.5-.644.834-.804.583-.322 1.25-.402 1.916-.241.667.16 1.167.562 1.584 1.125l7 11.33c.25.402.333.804.333 1.205 0 .643-.25 1.286-.75 1.688-.417.482-1 .723-1.667.723H4.917zM11.25 5.464l-7 11.33c-.25.402-.083.885.333 1.126.084.08.25.08.334.08H19c.25 0 .417-.08.583-.241.167-.16.25-.322.25-.563 0-.16 0-.24-.083-.401l-7-11.33c-.25-.403-.75-.483-1.167-.322-.166.08-.25.16-.333.321zm1.583 6.911V9.161c0-.482-.333-.804-.833-.804-.5 0-.833.322-.833.804v3.214c0 .482.333.804.833.804.5 0 .833-.322.833-.804zm-.25 3.777c.167-.16.25-.322.25-.563 0-.08 0-.24-.083-.321 0-.08-.083-.16-.167-.241 0 0-.083-.08-.166-.08-.084 0-.084-.08-.167-.08s-.083 0-.167-.081c-.166 0-.333 0-.5.08-.083 0-.166.08-.25.16-.083.081-.166.162-.166.242 0 .08-.084.16-.084.321 0 .241.084.402.25.563.167.16.334.24.584.24.333 0 .5-.08.666-.24z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#u02mx5xtca)",
  transform: "translate(-1937 -1027) translate(1922 1012)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(15 15.429)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "1rrnl11qyc",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#0r7ktetf5b"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#1rrnl11qyc)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24.24V23.374H0z"
}))))));
function SvgIconsFeatherAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFeatherAlertTriangle);
export default __webpack_public_path__ + "static/media/icons-feather-alert-triangle.d141c792a3935c86b5d378d953d3cb14.svg";
export { ForwardRef as ReactComponent };